import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationsApi } from "../api/notifications.api";
import {
  allNotificationsMarkedRead,
  notificationMarkedRead,
  notificationsLoaded,
  notificationsRequestFailed,
  notificationsRequestStarted,
  unreadCountLoaded,
} from "./notifications.slice";

function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return "Something went wrong";
}

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (_: void, { dispatch }) => {
    dispatch(notificationsRequestStarted());
    try {
      const notifications = await notificationsApi.list();
      dispatch(notificationsLoaded(notifications));
    } catch (err) {
      dispatch(notificationsRequestFailed(errorMessage(err)));
      throw err;
    }
  },
);

export const fetchUnreadCount = createAsyncThunk(
  "notifications/fetchUnreadCount",
  async (_: void, { dispatch }) => {
    const { count } = await notificationsApi.unreadCount();
    dispatch(unreadCountLoaded(count));
  },
);

export const markNotificationRead = createAsyncThunk(
  "notifications/markRead",
  async (id: string, { dispatch }) => {
    const notification = await notificationsApi.markRead(id);
    dispatch(notificationMarkedRead(notification));
  },
);

export const markAllNotificationsRead = createAsyncThunk(
  "notifications/markAllRead",
  async (_: void, { dispatch }) => {
    await notificationsApi.markAllRead();
    dispatch(allNotificationsMarkedRead());
  },
);
